import { useEffect, useState } from "react";

import styles from "../../../../styles/mensageria.module.scss";

import classNames from "classnames/bind";
import { Button } from "../../../components/Button";
import { Hairline } from "../../../components/Hairline";
import { Input } from "../../../components/Input";
import { Label } from "../../../components/Label";
import { Radio } from "../../../components/Radio";
import { If } from "../../../components/control-statements";
import { Icon } from "../../../components/core/Icon";
import { Environment } from "../../../core/Environment";

const css = classNames.bind(styles);

export const TemplateButtons = ({ template, onChangeTemplate }) => {
  const [configureButton, setConfigureButton] = useState({
    default: false,
    one: false,
    two: false,
  });

  const [buttons, setButtons] = useState({
    default: {
      type: "URL",
      text: "Acessar o Clube",
      url: Environment?.configurations?.wallet?.configs?.store,
      active: true,
    },
    one: {},
    two: {},
  });

  const countSelectedButtons = Object.values(buttons).filter(
    (button) => button?.active === true
  ).length;

  useEffect(() => {
    const templateButtons = (template?.structure?.buttons).map((button) => ({
      ...button,
      active: button?.text?.length > 0,
    }));
    if (templateButtons?.length > 0) {
      setButtons({
        default: templateButtons?.[0] || buttons.default,
        one: templateButtons?.[1] || buttons.one,
        two: templateButtons?.[2] || buttons.two,
      });
    }
  }, [template]);

  const updateTemplate = (fields) => {
    if (fields?.buttons) {
      onChangeTemplate({
        ...template,
        structure: {
          ...template.structure,
          buttons: [
            fields.buttons.default,
            fields.buttons.one,
            fields.buttons.two,
          ],
        },
      });
    }
  };

  const checkButtonIsValid = (item) => {
    const button = buttons[item];

    if (button?.type === "PHONE_NUMBER") {
      return !(
        button?.text &&
        button?.ddd?.length === 2 &&
        button?.phone?.length === 10
      );
    }

    if (button?.type === "URL") {
      return !(button?.text && button?.url);
    }
  };

  return (
    <div>
      <Label className="mb-10">Botões ({countSelectedButtons})</Label>
      <p className={styles.addButtonsLimit}>
        É possível adicionar até 3 botões.
      </p>

      <div className={styles.buttonsContainer}>
        <div className="d-flex align-center justify-between">
          <p className={styles.label}>Botão 1</p>
        </div>

        <If cond={!configureButton.default}>
          <If cond={buttons.default.active}>
            <div className="d-flex align-center">
              <div
                className={styles.club}
                onClick={() =>
                  setConfigureButton({ ...configureButton, default: true })
                }
              >
                {buttons.default.text}
              </div>
              <div
                className={styles.remove}
                onClick={() => {
                  setConfigureButton({ ...configureButton, default: false });
                  updateTemplate({
                    buttons: {
                      ...buttons,
                      default: {
                        type: "PHONE_NUMBER",
                        text: null,
                        ddd: null,
                        phone: null,
                        url: null,
                        active: false,
                      },
                    },
                  });
                }}
              >
                <Icon name="times" regular size="lg" />
              </div>
            </div>
          </If>
          <If cond={!buttons.default.active}>
            <div
              className={styles.button}
              onClick={() =>
                setConfigureButton({ ...configureButton, default: true })
              }
            >
              Configurar botão
            </div>
          </If>
        </If>

        <If cond={configureButton.default}>
          <div className={styles.buttonBox}>
            <div className={styles.header}>
              <p>Selecione o tipo do botão</p>
              <div
                className={styles.close}
                onClick={() => {
                  setConfigureButton({ ...configureButton, default: false });
                }}
              >
                <i className="far fa-times " />
              </div>
            </div>
            <Radio
              value="PHONE_NUMBER"
              checked={buttons.default.type}
              onChange={(e) => {
                updateTemplate({
                  buttons: {
                    ...buttons,
                    default: { ...buttons.default, type: e.target.value },
                  },
                });
              }}
              className="mb-10"
            >
              Telefone
            </Radio>
            <Radio
              value="URL"
              checked={buttons.default.type}
              onChange={(e) => {
                updateTemplate({
                  buttons: {
                    ...buttons,
                    default: { ...buttons.default, type: e.target.value },
                  },
                });
              }}
            >
              URL
            </Radio>
            <Hairline solid className="mt-20 mb-20" />
            <Input
              label="Texto do botão"
              className="mb-10"
              design="three"
              value={buttons.default.text}
              onChange={(e) =>
                updateTemplate({
                  buttons: {
                    ...buttons,
                    default: { ...buttons.default, text: e.target.value },
                  },
                })
              }
            />
            <If cond={buttons.default.type === "PHONE_NUMBER"}>
              <div className="d-flex align-center">
                <Input
                  placeholder="00"
                  mask="99"
                  design="three"
                  className="flex"
                  value={buttons.default.ddd}
                  onChange={(e) =>
                    updateTemplate({
                      buttons: {
                        ...buttons,
                        default: { ...buttons.default, ddd: e.target.value },
                      },
                    })
                  }
                />
                <Input
                  placeholder="00000-0000"
                  mask="99999-9999"
                  design="three"
                  className="w-100 ml-15"
                  value={buttons.default.phone}
                  onChange={(e) =>
                    updateTemplate({
                      buttons: {
                        ...buttons,
                        default: { ...buttons.default, phone: e.target.value },
                      },
                    })
                  }
                />
              </div>
            </If>
            <If cond={buttons.default.type === "URL"}>
              <Input
                placeholder="https://"
                design="three"
                className="w-100 mt-10 mb-15"
                value={buttons.default.url}
                onChange={(e) =>
                  updateTemplate({
                    buttons: {
                      ...buttons,
                      default: { ...buttons.default, url: e.target.value },
                    },
                  })
                }
              />
            </If>
            <Button
              className="w-100 mt-15"
              design="primary"
              onClick={() => {
                setConfigureButton({ ...configureButton, default: false });
                updateTemplate({
                  buttons: {
                    ...buttons,
                    default: { ...buttons.default, active: true },
                  },
                });
              }}
              disabled={checkButtonIsValid("default")}
            >
              Utilizar botão
            </Button>
          </div>
        </If>

        <Hairline solid className="mt-20 mb-20" />

        <div className="d-flex align-center justify-between">
          <p className={styles.label}>Botão 2</p>
        </div>
        <If cond={!configureButton.one}>
          <If cond={buttons.one.active}>
            <div className="d-flex align-center">
              <div
                className={styles.club}
                onClick={() =>
                  setConfigureButton({ ...configureButton, one: true })
                }
              >
                {buttons.one.text}
              </div>
              <div
                className={styles.remove}
                onClick={() => {
                  setConfigureButton({ ...configureButton, one: false });
                  updateTemplate({
                    buttons: {
                      ...buttons,
                      one: {
                        type: "PHONE_NUMBER",
                        text: null,
                        ddd: null,
                        phone: null,
                        url: null,
                        active: false,
                      },
                    },
                  });
                }}
              >
                <Icon name="times" regular size="1x" />
              </div>
            </div>
          </If>
          <If cond={!buttons.one.active}>
            <div
              className={styles.button}
              onClick={() =>
                setConfigureButton({ ...configureButton, one: true })
              }
            >
              Configurar botão
            </div>
          </If>
        </If>

        <If cond={configureButton.one}>
          <div className={styles.buttonBox}>
            <div className={styles.header}>
              <p>Selecione o tipo do botão</p>
              <div
                className={styles.close}
                onClick={() => {
                  setConfigureButton({ ...configureButton, one: false });
                }}
              >
                <i className="far fa-times " />
              </div>
            </div>
            <Radio
              value="PHONE_NUMBER"
              checked={buttons.one.type}
              onChange={(e) => {
                updateTemplate({
                  buttons: {
                    ...buttons,
                    one: { ...buttons.one, type: e.target.value },
                  },
                });
              }}
              className="mb-10"
            >
              Telefone
            </Radio>
            <Radio
              value="URL"
              checked={buttons.one.type}
              onChange={(e) => {
                updateTemplate({
                  buttons: {
                    ...buttons,
                    one: { ...buttons.one, type: e.target.value },
                  },
                });
              }}
            >
              URL
            </Radio>
            <Hairline solid className="mt-20 mb-20" />
            <Input
              label="Texto do botão"
              className="mb-10"
              design="three"
              value={buttons.one.text}
              onChange={(e) =>
                updateTemplate({
                  buttons: {
                    ...buttons,
                    one: { ...buttons.one, text: e.target.value },
                  },
                })
              }
            />
            <If cond={buttons.one.type === "PHONE_NUMBER"}>
              <div className="d-flex align-center">
                <Input
                  placeholder="00"
                  design="three"
                  mask="99"
                  className="flex"
                  value={buttons.one.ddd}
                  onChange={(e) =>
                    updateTemplate({
                      buttons: {
                        ...buttons,
                        one: { ...buttons.one, ddd: e.target.value },
                      },
                    })
                  }
                />
                <Input
                  placeholder="00000-0000"
                  design="three"
                  mask="99999-9999"
                  className="w-100 ml-15"
                  value={buttons.one.phone}
                  onChange={(e) =>
                    updateTemplate({
                      buttons: {
                        ...buttons,
                        one: { ...buttons.one, phone: e.target.value },
                      },
                    })
                  }
                />
              </div>
            </If>
            <If cond={buttons.one.type === "URL"}>
              <Input
                placeholder="https://"
                design="three"
                className="w-100 mt-10 mb-15"
                value={buttons.one.url}
                onChange={(e) =>
                  updateTemplate({
                    buttons: {
                      ...buttons,
                      one: { ...buttons.one, url: e.target.value },
                    },
                  })
                }
              />
            </If>
            <Button
              className="w-100 mt-15"
              design="primary"
              onClick={() => {
                setConfigureButton({ ...configureButton, one: false });
                updateTemplate({
                  buttons: {
                    ...buttons,
                    one: { ...buttons.one, active: true },
                  },
                });
              }}
              disabled={checkButtonIsValid("one")}
            >
              Utilizar botão
            </Button>
          </div>
        </If>

        <Hairline solid className="mt-20 mb-20" />
        <div className="d-flex align-center justify-between">
          <p className={styles.label}>Botão 3</p>
        </div>
        <If cond={!configureButton.two}>
          <If cond={buttons.two.active}>
            <div className="d-flex align-center">
              <div
                className={styles.club}
                onClick={() =>
                  setConfigureButton({ ...configureButton, two: true })
                }
              >
                {buttons.two.text}
              </div>
              <div
                className={styles.remove}
                onClick={() => {
                  setConfigureButton({ ...configureButton, two: false });
                  updateTemplate({
                    buttons: {
                      ...buttons,
                      two: {
                        type: "PHONE_NUMBER",
                        text: null,
                        ddd: null,
                        phone: null,
                        url: null,
                        active: false,
                      },
                    },
                  });
                }}
              >
                <Icon name="times" regular size="1x" />
              </div>
            </div>
          </If>
          <If cond={!buttons.two.active}>
            <div
              className={css({
                button: true,
                disabled: !buttons.one.active,
              })}
              onClick={() =>
                buttons.one.active &&
                setConfigureButton({ ...configureButton, two: true })
              }
            >
              Configurar botão
            </div>
          </If>
        </If>
        <If cond={configureButton.two}>
          <div className={styles.buttonBox}>
            <div className={styles.header}>
              <p>Selecione o tipo do botão</p>
              <div
                className={styles.close}
                onClick={() => {
                  setConfigureButton({ ...configureButton, two: false });
                }}
              >
                <Icon name="times" regular size="1x" />
              </div>
            </div>
            <Radio
              value="PHONE_NUMBER"
              checked={buttons.two.type}
              onChange={(e) => {
                updateTemplate({
                  buttons: {
                    ...buttons,
                    two: { ...buttons.two, type: e.target.value },
                  },
                });
              }}
              className="mb-10"
            >
              Telefone
            </Radio>
            <Radio
              value="URL"
              checked={buttons.two.type}
              onChange={(e) => {
                updateTemplate({
                  buttons: {
                    ...buttons,
                    two: { ...buttons.two, type: e.target.value },
                  },
                });
              }}
            >
              URL
            </Radio>
            <Hairline solid className="mt-20 mb-20" />
            <Input
              label="Texto do botão"
              className="mb-10"
              design="three"
              value={buttons.two.text}
              onChange={(e) =>
                updateTemplate({
                  buttons: {
                    ...buttons,
                    two: { ...buttons.two, text: e.target.value },
                  },
                })
              }
            />
            <If cond={buttons.two.type === "PHONE_NUMBER"}>
              <div className="d-flex align-center">
                <Input
                  placeholder="00"
                  mask="99"
                  design="three"
                  className="flex"
                  value={buttons.two.ddd}
                  onChange={(e) =>
                    updateTemplate({
                      buttons: {
                        ...buttons,
                        two: { ...buttons.two, ddd: e.target.value },
                      },
                    })
                  }
                />
                <Input
                  placeholder="00000-0000"
                  mask="99999-9999"
                  design="three"
                  className="w-100 ml-15"
                  value={buttons.two.phone}
                  onChange={(e) =>
                    updateTemplate({
                      buttons: {
                        ...buttons,
                        two: { ...buttons.two, phone: e.target.value },
                      },
                    })
                  }
                />
              </div>
            </If>
            <If cond={buttons.two.type === "URL"}>
              <Input
                placeholder="https://"
                design="three"
                className="w-100 mt-10 mb-15"
                value={buttons.two.url}
                onChange={(e) =>
                  updateTemplate({
                    buttons: {
                      ...buttons,
                      two: { ...buttons.two, url: e.target.value },
                    },
                  })
                }
              />
            </If>
            <Button
              className="w-100 mt-15"
              design="primary"
              onClick={() => {
                setConfigureButton({ ...configureButton, two: false });
                updateTemplate({
                  buttons: {
                    ...buttons,
                    two: { ...buttons.two, active: true },
                  },
                });
              }}
              disabled={checkButtonIsValid("two")}
            >
              Utilizar botão
            </Button>
          </div>
        </If>
      </div>
    </div>
  );
};
